<template>
  <div>
    <transition name="slide">
      <div v-show="visible" class="pro-wrapper" :class="[`mq-${$mq}`]">
        <div class="close" @click="hideModal()">
          <base-svg svg="close" height="0.85rem" fill="white"/>
        </div>

        <div class="pro-inner" :class="[`mq-${$mq}`]">    
          <div class="intro">
            <svg class="mark" width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8155 0.333496H25.2108L26 27.543L22.3455 28.528C19.0387 21.6494 15.9202 17.0187 12.0139 12.5849C14.2398 17.1322 16.1344 21.5113 17.9382 26.9294L14.7827 29.0821C12.9082 27.1982 11.3929 25.6079 10.0191 24.1662C9.32427 23.437 8.66566 22.7459 8.01512 22.0739C8.35032 23.228 8.64076 24.4982 8.89176 25.9526L9.11995 27.2747L6.17839 29.3335L1.08112 27.7603L2.16583 23.8458L4.67471 24.6202C3.75914 20.7111 2.39269 18.4625 0 14.55L2.80964 11.8344C6.16062 14.5846 8.47279 16.8392 10.8231 19.2666C8.89802 14.89 6.71962 10.7221 4.00901 5.5359C3.5973 4.74818 3.17331 3.93697 2.73606 3.09797L5.71753 0.595527C12.5625 7.05909 17.298 11.8688 21.7241 19.129L20.8155 0.333496Z" />
            </svg>

            <h3>Take control<br>of your news diet<br>with <span class="highlight">Nourish Pro</span></h3>

            <div class="features">
              <div class="feature">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.1667 11H16.1667C15.9015 11 15.6472 11.1054 15.4596 11.2929C15.2721 11.4804 15.1667 11.7348 15.1667 12C15.1667 12.2652 15.2721 12.5196 15.4596 12.7071C15.6472 12.8946 15.9015 13 16.1667 13H17.1667C17.432 13 17.6863 12.8946 17.8739 12.7071C18.0614 12.5196 18.1667 12.2652 18.1667 12C18.1667 11.7348 18.0614 11.4804 17.8739 11.2929C17.6863 11.1054 17.432 11 17.1667 11ZM17.1667 15H16.1667C15.9015 15 15.6472 15.1054 15.4596 15.2929C15.2721 15.4804 15.1667 15.7348 15.1667 16C15.1667 16.2652 15.2721 16.5196 15.4596 16.7071C15.6472 16.8946 15.9015 17 16.1667 17H17.1667C17.432 17 17.6863 16.8946 17.8739 16.7071C18.0614 16.5196 18.1667 16.2652 18.1667 16C18.1667 15.7348 18.0614 15.4804 17.8739 15.2929C17.6863 15.1054 17.432 15 17.1667 15ZM11.1667 9H17.1667C17.432 9 17.6863 8.89464 17.8739 8.70711C18.0614 8.51957 18.1667 8.26522 18.1667 8C18.1667 7.73478 18.0614 7.48043 17.8739 7.29289C17.6863 7.10536 17.432 7 17.1667 7H11.1667C10.9015 7 10.6472 7.10536 10.4596 7.29289C10.2721 7.48043 10.1667 7.73478 10.1667 8C10.1667 8.26522 10.2721 8.51957 10.4596 8.70711C10.6472 8.89464 10.9015 9 11.1667 9ZM21.1667 3H7.16675C6.90153 3 6.64718 3.10536 6.45964 3.29289C6.27211 3.48043 6.16675 3.73478 6.16675 4V7H3.16675C2.90153 7 2.64718 7.10536 2.45964 7.29289C2.2721 7.48043 2.16675 7.73478 2.16675 8V18C2.16675 18.7956 2.48282 19.5587 3.04543 20.1213C3.60804 20.6839 4.3711 21 5.16675 21H18.1667C19.2276 21 20.245 20.5786 20.9952 19.8284C21.7453 19.0783 22.1667 18.0609 22.1667 17V4C22.1667 3.73478 22.0614 3.48043 21.8739 3.29289C21.6863 3.10536 21.432 3 21.1667 3ZM6.16675 18C6.16675 18.2652 6.06139 18.5196 5.87385 18.7071C5.68632 18.8946 5.43196 19 5.16675 19C4.90153 19 4.64718 18.8946 4.45964 18.7071C4.2721 18.5196 4.16675 18.2652 4.16675 18V9H6.16675V18ZM20.1667 17C20.1667 17.5304 19.956 18.0391 19.581 18.4142C19.2059 18.7893 18.6972 19 18.1667 19H7.98675C8.10317 18.6793 8.16404 18.3411 8.16675 18V5H20.1667V17ZM11.1667 13H12.1667C12.432 13 12.6863 12.8946 12.8739 12.7071C13.0614 12.5196 13.1667 12.2652 13.1667 12C13.1667 11.7348 13.0614 11.4804 12.8739 11.2929C12.6863 11.1054 12.432 11 12.1667 11H11.1667C10.9015 11 10.6472 11.1054 10.4596 11.2929C10.2721 11.4804 10.1667 11.7348 10.1667 12C10.1667 12.2652 10.2721 12.5196 10.4596 12.7071C10.6472 12.8946 10.9015 13 11.1667 13ZM11.1667 17H12.1667C12.432 17 12.6863 16.8946 12.8739 16.7071C13.0614 16.5196 13.1667 16.2652 13.1667 16C13.1667 15.7348 13.0614 15.4804 12.8739 15.2929C12.6863 15.1054 12.432 15 12.1667 15H11.1667C10.9015 15 10.6472 15.1054 10.4596 15.2929C10.2721 15.4804 10.1667 15.7348 10.1667 16C10.1667 16.2652 10.2721 16.5196 10.4596 16.7071C10.6472 16.8946 10.9015 17 11.1667 17Z" fill="#14B31F"/>
                </svg>
                <span>Personal<br>Daily Edition</span>
              </div>

              <div class="feature">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.4201 11.6C20.4001 6.91 16.6001 4 12.5001 4C8.40007 4 4.60007 6.91 2.58007 11.6C2.525 11.7262 2.49658 11.8623 2.49658 12C2.49658 12.1377 2.525 12.2738 2.58007 12.4C4.60007 17.09 8.40007 20 12.5001 20C16.6001 20 20.4001 17.09 22.4201 12.4C22.4751 12.2738 22.5036 12.1377 22.5036 12C22.5036 11.8623 22.4751 11.7262 22.4201 11.6ZM12.5001 18C9.33007 18 6.33007 15.71 4.60007 12C6.33007 8.29 9.33007 6 12.5001 6C15.6701 6 18.6701 8.29 20.4001 12C18.6701 15.71 15.6701 18 12.5001 18ZM12.5001 8C11.7089 8 10.9356 8.2346 10.2778 8.67412C9.61999 9.11365 9.1073 9.73836 8.80455 10.4693C8.5018 11.2002 8.42258 12.0044 8.57693 12.7804C8.73127 13.5563 9.11223 14.269 9.67164 14.8284C10.231 15.3878 10.9438 15.7688 11.7197 15.9231C12.4956 16.0775 13.2999 15.9983 14.0308 15.6955C14.7617 15.3928 15.3864 14.8801 15.8259 14.2223C16.2655 13.5645 16.5001 12.7911 16.5001 12C16.5001 10.9391 16.0786 9.92172 15.3285 9.17157C14.5783 8.42143 13.5609 8 12.5001 8ZM12.5001 14C12.1045 14 11.7178 13.8827 11.3889 13.6629C11.06 13.4432 10.8037 13.1308 10.6523 12.7654C10.5009 12.3999 10.4613 11.9978 10.5385 11.6098C10.6157 11.2219 10.8061 10.8655 11.0859 10.5858C11.3656 10.3061 11.7219 10.1156 12.1099 10.0384C12.4978 9.96126 12.9 10.0009 13.2654 10.1522C13.6309 10.3036 13.9432 10.56 14.163 10.8889C14.3828 11.2178 14.5001 11.6044 14.5001 12C14.5001 12.5304 14.2894 13.0391 13.9143 13.4142C13.5392 13.7893 13.0305 14 12.5001 14Z" fill="#14B31F"/>
                </svg>

                <span>Ad Free. Forever</span>
              </div>

              <div class="feature">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.8247 2.00195C20.6934 2.00188 20.5633 2.02769 20.4419 2.07792C20.3206 2.12815 20.2103 2.20181 20.1174 2.29468C20.0246 2.38755 19.9509 2.49782 19.9007 2.61918C19.8504 2.74054 19.8246 2.87061 19.8247 3.00195V3.63867C18.9813 4.68438 17.9154 5.52887 16.7044 6.11067C15.4935 6.69248 14.1681 6.99696 12.8247 7.00195H6.82471C6.02932 7.00282 5.26677 7.31917 4.70435 7.88159C4.14192 8.44401 3.82558 9.20657 3.82471 10.002V12.002C3.82558 12.7973 4.14192 13.5599 4.70435 14.1223C5.26677 14.6847 6.02932 15.0011 6.82471 15.002H7.3085L4.90577 20.6084C4.84047 20.7604 4.81396 20.9263 4.82862 21.0911C4.84328 21.256 4.89864 21.4146 4.98974 21.5528C5.08084 21.6909 5.20482 21.8043 5.35056 21.8827C5.49629 21.9611 5.65922 22.0021 5.82471 22.002H9.82471C10.0205 22.0021 10.2119 21.9446 10.3753 21.8368C10.5387 21.729 10.6668 21.5755 10.7437 21.3955L13.4674 15.04C14.698 15.1303 15.8971 15.472 16.9905 16.0439C18.084 16.6158 19.0485 17.4058 19.8247 18.365V19.002C19.8247 19.2672 19.9301 19.5215 20.1176 19.7091C20.3051 19.8966 20.5595 20.002 20.8247 20.002C21.0899 20.002 21.3443 19.8966 21.5318 19.7091C21.7194 19.5215 21.8247 19.2672 21.8247 19.002V3.00195C21.8248 2.87061 21.799 2.74054 21.7487 2.61918C21.6985 2.49782 21.6249 2.38755 21.532 2.29468C21.4391 2.2018 21.3288 2.12815 21.2075 2.07792C21.0861 2.02769 20.9561 2.00188 20.8247 2.00195ZM6.82471 13.002C6.55955 13.0018 6.30529 12.8964 6.1178 12.7089C5.9303 12.5214 5.82488 12.2671 5.82471 12.002V10.002C5.82489 9.73679 5.9303 9.48254 6.1178 9.29505C6.3053 9.10755 6.55955 9.00213 6.82471 9.00195H7.82471V13.002H6.82471ZM9.16553 20.002H7.34131L9.48389 15.002H11.3081L9.16553 20.002ZM19.8247 15.5238C17.853 13.8994 15.3794 13.0082 12.8247 13.0019H9.82471V9.0019H12.8247C15.3794 8.99537 17.853 8.10406 19.8247 6.47956V15.5238Z" fill="#14B31F"/>
                </svg>

                <span>Support Independence</span>
              </div>
            </div>

            <p>Get deeper news intelligence with <span class="highlight">Pro</span>.<br>Customised news edition, zero ads, retain your reading history, get new features first and support better news.</p>
          </div>

          <div class="product" :class="[`mq-${$mq}`]">
            <h4>Nourish Pro</h4>
            <h5>£5 per month</h5>

            <div class="metas">
              <div class="meta">
                <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.1773 6.53105L1.05053 5.25919C0.810205 4.98793 0.420565 4.98793 0.180242 5.25919C-0.0600807 5.53046 -0.0600807 5.97027 0.180242 6.24154L1.74237 8.00482C1.98278 8.27619 2.37259 8.27608 2.61287 8.00458L7.81998 2.1211C8.06018 1.8497 8.05998 1.40988 7.81954 1.13875C7.5791 0.86762 7.18946 0.86784 6.94926 1.13924L2.1773 6.53105Z" fill="white"/>
                </svg>
                <span>Cancel anytime</span>
              </div>

              <div class="meta">
                <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.1773 6.53105L1.05053 5.25919C0.810205 4.98793 0.420565 4.98793 0.180242 5.25919C-0.0600807 5.53046 -0.0600807 5.97027 0.180242 6.24154L1.74237 8.00482C1.98278 8.27619 2.37259 8.27608 2.61287 8.00458L7.81998 2.1211C8.06018 1.8497 8.05998 1.40988 7.81954 1.13875C7.5791 0.86762 7.18946 0.86784 6.94926 1.13924L2.1773 6.53105Z" fill="white"/>
                </svg>
                <span>Renews monthly</span>
              </div>
            </div>

            <StripeCheckout period="M" class="go-pro"/>
          </div>
        </div>

      </div>
    </transition>
    <div v-if="visibleBackground" @click="hideModal()" class="background"></div>
  </div>
</template>

<script>
  import StripeCheckout from 'app/components/Pro/Stripe.vue';

  export default {
    data() {
      return {
        visible: false,
        visibleBackground: false,
        isWorking: false,
      }
    },

    components: {
      StripeCheckout,
    },

    mounted () {
      this.EventBus.$on('modal:go-pro', () => {
        // Hide mobile navigation if expanded
        this.EventBus.$emit('header:hide');
        this.visibleBackground = true;
        this.visible = true;

        // Track when GoPro modal is shown
        this.EventBus.$emit('track:event', {
          label: 'GoPro: Show',
          once: true, // default
        });
      });
    },

    methods: {
      hideModal() {
        this.visible = false;
        this.visibleBackground = false;
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .background {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    z-index: 9999999;
    background: rgba($green-tone-6, 0.95);
  }

  // Mobile
  .pro-wrapper {
    position: fixed;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999999;
    background: rgba($green-tone-7, 1.0);
    color: $neutral-600;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);

    &.mq-md, &.mq-lg {
      top: 4rem;
      bottom: auto;
      max-width: 28rem;
      height: auto;
      border-radius: $border-radius;
    }

    .close {
      position: absolute;
      top: env(safe-area-inset-top);
      right: 0;
      padding: 1.5rem;
      z-index: 99;
      cursor: pointer;
      background: transparent;
    }

    .pro-inner {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 3.2rem 1.5rem;
      overflow-y: scroll;
      height: 100%;
      -ms-overflow-style: none;  // IE 10+
      overflow: -moz-scrollbars-none;  // Firefox
      &::-webkit-scrollbar {
        display: none; // Safari and Chrome
      }

      &.mq-md, &.mq-lg {
        padding: 4rem 2rem 4rem 2rem;
      }

      &.overflow-wrap {
        overflow: hidden;
      }

      .intro {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        .mark {
          margin-bottom: 1.5rem;
          fill: $green-tone-3;
        }

        h3 {
          font-family: 'Brawler';
          font-weight: normal;
          line-height: 135%;
          font-size: 1.8rem;
        }

        p {
          font-size: 0.95rem;
        }

        .highlight {
          color: $green-tone-3;
        }

        .features {
          display: flex;
          justify-content: space-evenly;
          margin: 2rem 0;

          .feature {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 1rem 0;
            flex: 1;

            span {
              margin-top: 1rem;
              font-weight: bold;
              font-size: 14px;
            }

            &:not(:last-child) {
              padding-right: 1rem;
              margin-right: 1rem;
              border-right: 1px solid rgba($green-tone-3, 0.25);
            }
          }
        }
      }

      .product {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        background: $green-tone-5;
        border-radius: 8px;
        padding: 2rem 1rem 7rem 1rem;
        margin: 0 1.5rem;
        text-align: center;
        margin-top: 3rem;

        h3 {
          font-size: 1.2rem;
          margin-bottom: 0.2rem;
          font-weight: bold;
        }

        h4 {
          font-size: 1rem;
          color: $green-tone-3;
          line-height: 160%;
        }

        .metas {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 1rem;

          .meta {
            font-size: 0.8rem;

            &:first-child {
              margin-right: 1rem;
            }

            span {
              margin-left: 0.5rem;
            }
          }
        }
      }
    }
  }
</style>